module.exports = __webpack_public_path__ + "img/gcash-app.cd2b519d.jpeg";